/**
 * Created by comoon on 2/18/16.
 * 询价状态
 * 与后台返回状态同步
 */


//0正常,1:正在计算,2:严重错误,无价,3:轻微错误有价,4:过期,5:用户已经预定

var Normal = {
    code: 0,
    real: "正常",
    text: "正常"
};

var Calculating = {
    code: 1,
    real: "计价中",
    text: "计算中"
};

var Fatal = {
    code: 2,
    real: "严重错误",
    text: "欢迎询价"
};

var Mistake = {
    code: 3,
    real: "轻微错误",
    text: "缺货"
};

var Deal = {
    code: 5,
    real: "已预定",
    text: "已预定"
};

module.exports = {
    Normal,
    Calculating,
    Fatal,
    Mistake,
    Deal,
    list: [Normal, Calculating, Fatal, Mistake, Deal]
};


/** WEBPACK FOOTER **
 ** ./script/conf/quote-status.js
 **/